import React from 'react';
import { Check, AlertTriangle } from 'lucide-react';
import { ActivityAction } from '@shared/activity/types';
import { relativeTime } from './relativeTime';

interface RecentActionNodeProps {
  action: ActivityAction;
}

export const RecentActionNode: React.FC<RecentActionNodeProps> = ({ action }) => {
  const isSuccess = action.status === 'success';

  return (
    <div className="flex items-center gap-2 pl-6 pr-2 py-1 text-xs text-muted-foreground hover:text-foreground transition-colors group">
      {isSuccess ? (
        <Check className="h-3 w-3 text-emerald-500 shrink-0" />
      ) : (
        <AlertTriangle className="h-3 w-3 text-destructive shrink-0" />
      )}
      <span className="truncate font-normal flex-1" title={action.label}>
        {action.label}
        {action.entity?.name && (
          <span className="text-muted-foreground/80 ml-1">
            ({action.entity.name})
          </span>
        )}
      </span>
      <span className="text-[10px] text-muted-foreground/60 shrink-0 font-mono">
        {relativeTime(action.at)}
      </span>
    </div>
  );
};
